import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/auth/Login';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import TokenForm from './pages/token/TokenForm';
import TokenDisplay from './pages/token/TokenDisplay';
import TokenList from './pages/token/TokenList';
import UserManagement from './pages/admin/UserManagement';

function AdminTokenPage() {
  const [generatedToken, setGeneratedToken] = useState(null);

  return (
    <>
      {!generatedToken ? (
        <TokenForm onGenerate={setGeneratedToken} />
      ) : (
        <TokenDisplay token={generatedToken.tokenRecord ? { ...generatedToken.tokenRecord, token: generatedToken.token } : generatedToken} onReset={() => setGeneratedToken(null)} />
      )}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Rutas del panel administrador */}
        <Route
          path="/panel-administrador/generar-token"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <AdminTokenPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/panel-administrador/ver-tokens"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <TokenList />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/panel-administrador/usuarios"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <UserManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        {/* Redirección inteligente según el rol */}
        <Route
          path="/"
          element={
            <ProtectedRoute>

            </ProtectedRoute>
          }
        />

        {/* Catch-all: si no existe la ruta, redirige a home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App; 